import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
const basename = (process.env.PUBLIC_URL || "/").replace(/\/+$/, "") || "/";
root.render(
    <BrowserRouter basename={basename}>
    <App />
    </BrowserRouter>

    );